import type { UserOrganizationHeaderCardProps } from "./user-organization-header-card.type";

import { Card, Typography, Skeleton } from "antd";
import classNames from "classnames";

import "./user-organization-header-card.style.less";

export const UserOrganizationHeaderCard = ({
  title,
  icon,
  secondaryTitle,
  loading,
  fixedWidth,
  extra,
  children,
}: UserOrganizationHeaderCardProps) => {
  const { Title, Paragraph } = Typography;

  return (
    <Card
      classNames={{
        root: classNames("user-organization-header-card", {
          "-fixed-width": fixedWidth,
        }),
        header: "user-organization-header-card--header",
        body: "user-organization-header-card--body",
      }}
      extra={extra}
      title={
        <>
          <Title level={5} className="secondary-title">
            {loading ? (
              <Skeleton paragraph={false} title={{ width: "100px" }} />
            ) : (
              secondaryTitle
            )}
          </Title>
          <Title level={2} className="title">
            {loading ? (
              <Skeleton paragraph={false} title={{ width: "200px" }} />
            ) : (
              <>
                {icon} {title}
              </>
            )}
          </Title>
        </>
      }
    >
      <Paragraph type="secondary">
        {loading ? <Skeleton paragraph={false} /> : children}
      </Paragraph>
    </Card>
  );
};
